import React from "react"

export const PortfoilioConfirmation: React.FC = () => {
    return <div className="leadcapturelp-confirmation-other">
        <h1 className="leadcapturelp-confirmation-other-title">Thank you! We’ll be in touch shortly.</h1>
        <div className="leadcapturelp-confirmation-other-body">
            <div className="leadcapturelp-confirmation-other-body-caption">See LiquidSpace in action...</div>
            <div className="leadcapturelp-confirmation-other-body-title">GoFundMe’s flexible workplace: 121 cities, 92% satisfaction.</div>
            <div className="leadcapturelp-confirmation-other-body-actions">
                <a href="https://resources.liquidspace.com/inside-gofundme-flex-workplace-strategy" className="btn btn-sm btn-primary-on-dark" target="_blank">Read the case study</a>
            </div>
        </div>
    </div>
}